/**
 * Config files loader
 *
 */
import merge from 'lodash/merge';

const partial = (func, ...defaultArgs) => (...args) => func(...defaultArgs, ...args);

/* eslint-disable no-console */

export function isEnabled(config, name) {
    if (typeof config.enable[name] === 'undefined') {
        console.log(`Missing enable flag ${name}`);
    }

    if (typeof config.enable[name] === 'string') {
        return config.enable[name] === '1';
    }

    return !!config.enable[name];
}

export function getUrl(config, name, hasLogo) {
    // TODO: remove hasLogo option when we also switch Zebra images to Akamai
    let specialName = name;
    if (name === 'campaign') {
        const cheetahCampaign = 'cheetah-campaign';
        specialName = !hasLogo
            && (config.view.url.secure[cheetahCampaign] || config.view.url[cheetahCampaign])
            ? cheetahCampaign : name;
    }

    return config.view.url.secure[specialName] || config.view.url[specialName];
}

export function getSwitchUrl(config) {
    return config.domain && config.domain.switchurl ? config.domain.switchurl : null;
}

export function getSwitchUrlAppdomains(config) {
    const switchUrl = getSwitchUrl(config);

    return switchUrl && switchUrl.appdomains ? switchUrl.appdomains : null;
}

export function getCountryCode(config) {
    return config.countryCode;
}

export function getCountryCodeForAppdomainId(config, appdomainId) {
    if (!config.locale || !config.locale[appdomainId]) {
        return 'DE';
    }

    const [languageCode = ''] = config.locale[appdomainId].split('_');

    return languageCode;
}

export function getTimeConstants(config, count) {
    if (!config.timeRules) return count;

    const { few, many } = config.timeRules;

    if (count === 1) {
        return count;
    }
    if (few && count >= few.min && count <= few.max) {
        return 2;
    }
    if (many && count >= many.min && count <= many.max) {
        return 3;
    }

    return count;
}

// ------

export function loadConfigInPath(directory) {
    try {
        return require(`${directory}/config.json`);
    }
    catch (error) {
        console.warn(`Could not load files in ${directory}`);

        return {};
    }
}

export function loadFromFilesystemWithCustomLoader(loadFile, environment = 'development', appdomain = undefined) {
    const config = {};

    if (appdomain) {
        config.appdomainid = Number(appdomain);
        config.appdomain = Number(appdomain);
    }

    // merge environment specific config into default config
    merge(config, loadFile('/default'));
    if (appdomain) {
        merge(config, loadFile(`/default/${appdomain}`));
    }
    merge(config, loadFile(`/${environment}`));
    if (appdomain) {
        merge(config, loadFile(`/${environment}/${appdomain}`));
    }

    // use local gitignored config for overwrites
    if (['development', 'development-production'].includes(environment)) {
        merge(config, loadFile('/local'));
    }

    return config;
}

export function loadFromFilesystem(path, environment = 'development', appdomain) {
    return loadFromFilesystemWithCustomLoader(file => loadConfigInPath(`${path}${file}`), environment, appdomain);
}

export const injectHelperFunctions = (config) => Object.assign(config, {
    isEnabled: partial(isEnabled, config),
    getUrl: partial(getUrl, config),
    getSwitchUrl: partial(getSwitchUrl, config),
    getSwitchUrlAppdomains: partial(getSwitchUrlAppdomains, config),
    getCountryCode: partial(getCountryCode, config),
    getTimeConstants: partial(getTimeConstants, config),
    getCountryCodeForAppdomainId: partial(getCountryCodeForAppdomainId, config),
});
